// @ts-nocheck



import CommonApi from './../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';

export const convertDataToServer = (
measuringDeviceCertificationCost) => (
{
  ...measuringDeviceCertificationCost,
  cost: convertFromRubToKop(measuringDeviceCertificationCost.cost)
});

export const convertDataFromServer = (
measuringDeviceCertificationCost) => (
{
  ...measuringDeviceCertificationCost,
  cost: convertFromKopToRub(measuringDeviceCertificationCost.cost)
});

const measuringDeviceCertificationCost = new CommonApi(
  'measuringDeviceCertificationCost',
  'Стоимость тарировки цистерн',
  convertDataToServer,
  convertDataFromServer
);

export default {
  ...measuringDeviceCertificationCost
};
